<template>
  <v-container fluid>
    <v-data-table :headers="headers" class="elevation-1" :items="permissoes" :loading="loading">
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters :filters="filters" v-model="filtrosAtivos"></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            depressed
            color="accent"
            :to="{ name: 'permissoes-formulario', path: 'novo' }"
            v-if="perms.includes('auth.criar_permissoes')"
          >
            <v-icon class="mdi mdi-shield-plus-outline mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small v-if="perms.includes('auth.editar_permissoes')" @click="editar(item.id)">
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar permissão de acesso"
          texto="Confirma a exclusão? Esta ação pode comprometer as funcionalidades do sistema"
          v-if="perms.includes('auth.excluir_permissoes')"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
export default {
  components: { DatatableFilters, DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Descrição", value: "descricao" },
        { text: "Grupo", value: "grupo" },
        { text: "Ações", value: "actions", sortable: false, align: "center" }
      ],
      filters: [
        {
          name: "pesquisa",
          label: "Nome/Descrição",
          type: "text",
          defaultValue: ""
        },
        {
          name: "grupo",
          label: "Grupo",
          type: "select",
          multiple: true,
          options: []
        }
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.permissoes") || "{}"
      ),
      loading: true
    };
  },
  computed: {
    ...mapState({
      perms: state => state.usuarios.usuarioAtivo.permissoes,
      permissoes: state => state.permissao.permissoes
    })
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("permissao/deletar", id);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    editar(id) {
      this.$router.push({
        name: "permissoes-formulario-editar",
        params: { id }
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("permissao/listar", this.filtrosAtivos);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.permissoes", JSON.stringify(val));
      this.listar();
    }
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de permissões de acesso"
    });
    this.$store.dispatch("permissao/listarGrupos").then(grupos => {
      this.filters.find(f => f.name === "grupo").options = grupos.map(g => ({
        text: g,
        value: g
      }));
    });
    this.listar();
  }
};
</script>
